// extracted by mini-css-extract-plugin
var _1 = "pages-module__header___ZkLpM";
var _2 = "pages-module__header-content___enHIX";
var _3 = "pages-module__header-content-column___hNd9t";
var _4 = "pages-module__header-content___enHIX";
var _5 = "pages-module__header-content-column___hNd9t";
var _6 = "pages-module__separator___J7FDk";
export { _1 as "header", _2 as "header-content", _3 as "header-content-column", _4 as "headerContent", _5 as "headerContentColumn", _6 as "separator" }
